export default __webpack_public_path__ + "bda39d844f8c7d374db41ed745fb0b05.svg";